module.exports = __webpack_public_path__ + "static/media/chime.8e59d0eb.mp3";